import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import { useFormikContext } from 'formik'
import {
  DEFAULT_VARIATION_OPTIONS_BY_TYPE,
  EVariationTypes,
} from 'core/common/constants/multivariation'
import i18n from 'core/common/i18n'
import { Button } from 'core/components/Core'
import VariationsAutocompleteField from 'core/components/VariationsAutocompleteField'

export const AttributeField = ({
  handleSubmit,
  handleDelete,
  variationType,
  className = '',
  name = '',
}) => {
  const { setFieldValue, values, touched, errors } = useFormikContext()

  if (!variationType) {
    return null
  }

  return (
    <div className={className}>
      <div className="d-flex">
        <VariationsAutocompleteField
          className="flex-1"
          error={touched[name] && errors[name]}
          value={values[name]}
          options={DEFAULT_VARIATION_OPTIONS_BY_TYPE[variationType]}
          inputLabel={i18n.t(`multivariation.types.${variationType}`)}
          onChange={(_, newValue) => setFieldValue(name, newValue)}
          showAvatar={variationType === EVariationTypes.COLOR}
        />

        {handleDelete && (
          <div className="ml-4 flex-1">
            <DeleteOutlineIcon color="error" onClick={handleDelete} className="cursor-pointer" />
          </div>
        )}
      </div>

      {handleSubmit && (
        <Button
          color="primary"
          startIcon={<AddOutlinedIcon color="primary" />}
          variant="outlined"
          onClick={handleSubmit}
          className="mt-3"
        >
          Adicionar
        </Button>
      )}
    </div>
  )
}
